import { Component, OnInit, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-motivo-bloqueio',
  templateUrl: './modal-motivo-bloqueio.component.html',
  styleUrls: ['./modal-motivo-bloqueio.component.scss']
})
export class ModalMotivoBloqueioComponent implements OnInit {

  @Input() cabecalho: string;
  justificativa = new FormControl('', [Validators.required]);

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  setJustificativa( justificativa ){
    this.justificativa = justificativa
  }
}
